const RadiAnt = () =>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="5 5 210 170" width="24" height="24" style={{fill:'currentColor'}}>
    <path d="M16 32h40c12 0 21 3 27 10 6 6 9 14 9 23 0 8-2 14-7 20-4 5-10 9-17 11l27 44H72L48 100H38v40H16V32zm22 16v36h25c7 0 13-2 17-6s6-9 6-14c0-6-2-10-6-14s-10-5-16-5H38zM112 140l40-108h16l40 108h-18l-10-28h-40l-10 28h-18zm32-44h30l-15-44-15 44z"/>
  </svg>

export default RadiAnt
